import { useEffect } from "react";

export default function useValidityFieldsHook({
  fieldsValidity,
  logicForValidityFields,
  setFieldsValidity,
  dependencies,
  willNotRun = false,
}) {
  useEffect(() => {
    if (willNotRun) return;
    if (logicForValidityFields) logicForValidityFields();
    if (setFieldsValidity) setFieldsValidity(fieldsValidity);
    return () => {
      setFieldsValidity([]);
    };
  }, [dependencies]);
}
